import { render } from "./ModalUI.vue?vue&type=template&id=70c22645&scoped=true"
import script from "./ModalUI.vue?vue&type=script&lang=js"
export * from "./ModalUI.vue?vue&type=script&lang=js"

import "./ModalUI.vue?vue&type=style&index=0&id=70c22645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c22645"]])

export default __exports__